export default function TemplateSelectionConfirmation() {
    return (
        <div>Click DONE to create a new questionnaire</div>
    )
}